import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useUserStore } from '../../store/user.store'
import InstituteSelect from './InstituteSelect'
import DepartmentSelect from './DepartmentSelect'
import { useSearchParams } from 'react-router-dom'
import { useOrganizationStore } from '../../store/organization.store'
import CountCard from '../common/CountCard'
import api from '../../service/api'
import { toast } from 'react-toastify'

const AuditPageHeader = ( { noDepartment = false, countCards, loading, title, subtitle } ) => {

    const [departments, setDepartments] = useState( [] )
    const [loadingDepartments, setLoadingDepartments] = useState( false )

    const [searchParams, setSearchParams] = useSearchParams( { selectedDepartment: "all", selectedInstitute: "all" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const UserStore = useUserStore()
    const OrganizationStore = useOrganizationStore()

    const handleInstituteChange = async val => {
        const newParams = new URLSearchParams( searchParams )
        newParams.set( 'selectedInstitute', val )
        newParams.set( 'selectedDepartment', "all" )
        setSearchParams( newParams, { replace: true } )
    }

    const handleDepartmentChange = val => {
        const newParams = new URLSearchParams( searchParams )
        newParams.set( 'selectedDepartment', val )
        setSearchParams( newParams, { replace: true } )
    }

    useEffect( () => {
        const getData = async () => {
            setDepartments( [] )
            try {
                if ( "PRINCIPAL" === UserStore.getUser.user_role || UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) {
                    setLoadingDepartments( true )
                    const institute = selectedInstitute !== "all" ? selectedInstitute : ""
                    if ( ( UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) && ( !OrganizationStore.getOrganization || OrganizationStore.getOrganization?.length === 0 ) ) {
                        if ( OrganizationStore.getOrganization?.length === 0 )
                            await OrganizationStore.fetchOrganization()
                        setLoadingDepartments( false )
                    }
                    if ( !noDepartment ) {

                        let fetchDepartments = true
                        if ( "PRINCIPAL" !== UserStore.getUser.user_role && !institute )
                            fetchDepartments = false
                        if ( fetchDepartments === true ) {
                            const { data: { data } } = await api.audit.fetchInstituteDepartment( { institute } )
                            setDepartments( data )
                        }
                    }
                }
            } catch ( err ) {
                toast( err?.response?.data?.message || "Something went wrong while fetching the institute's department." )
            } finally {
                setLoadingDepartments( false )
            }
        }
        getData()
    }, [UserStore, selectedInstitute, OrganizationStore, setSearchParams, noDepartment] )

    return (
        <Box sx={{ flexShrink: 0 }}>
            <Box display="flex" flexWrap="wrap" gap="20px" justifyContent="space-between" >
                <Box display="flex" flexGrow={1} gap="20px" flexDirection="column" justifyContent="space-between">
                    <Box>
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">{title}</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>{subtitle}</Typography>
                    </Box>

                    {countCards.length > 0 && <Box display="grid" gap="10px" width="100%" gridTemplateColumns={{ lg: "repeat(6,1fr)", md: "repeat(4,1fr)", sm: "repeat(3fr,1fr)", xs: "repeat(2,1fr)" }}>
                        {countCards.map( ( countCard, index ) => (
                            <CountCard key={index} loading={loading} variant="stacked" label={countCard.label} icon={countCard.icon} value={countCard.value} secondary={countCard.secondary} secondaryLabel={countCard.secondaryLabel} />
                        ) )}
                    </Box>}

                    <Box>
                        <Box display="flex" gap="20px" flexWrap="wrap">

                            {( UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) && <InstituteSelect disabled={loading} selectedInstitute={selectedInstitute} handleInstituteChange={handleInstituteChange} />}

                            {!noDepartment && ( UserStore.getUser.user_role === 'PRINCIPAL' || UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) && <DepartmentSelect disabled={loading || loadingDepartments || ( selectedInstitute === "all" && UserStore.getUser.user_role !== 'PRINCIPAL' )} departments={departments} handleDepartmentChange={handleDepartmentChange} selectedDepartment={selectedDepartment} />}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AuditPageHeader
